module.exports = __webpack_public_path__ + "static/img/mini5.05e67840.png";